import { observer } from 'mobx-react-lite'
import { Modal, Typography } from 'antd'
import { useNotification } from '@/Ship/Hooks/useNotification'
import { SimpleFormFieldCell } from '../SimpleFormFieldCell'
import type { PushModalStore } from '../../Stores/PushModalStore'

const { Text } = Typography

interface Props {
    store: PushModalStore
}

export const PushModal = observer(({ store }: Props) => {
    const { showSuccess, showError } = useNotification()

    return (
        <Modal
            title="Відправити push-повідомлення"
            open={store.open}
            onOk={() => store.send({ success: showSuccess, error: showError })}
            onCancel={() => store.close()}
            confirmLoading={store.loading}
            okText="Відправити"
            cancelText="Скасувати"
        >
            <div style={{ marginTop: 16 }}>
                <Text>Текст повідомлення <span style={{ color: 'red' }}>*</span>:</Text>
                <SimpleFormFieldCell
                    key={`push-modal-${store.open}`}
                    fieldName="message"
                    fieldDef={{ type: 'textarea', inputProps: { rows: 3, placeholder: 'Введіть текст push-повідомлення...' } }}
                    initialValue=""
                    onChange={(val) => store.setMessage(val ?? '')}
                />
            </div>
        </Modal>
    )
})
